module.exports = __webpack_public_path__ + "static/media/cbs-tv-ncis1.afe07560.png";